import { Alert, Button, Col, Descriptions, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Image } from 'antd';

import { Task, TaskStatus, taskStatusKorean } from '../../modules/tasks';
import { useState } from 'react';
import TaskCommentListComponent from './TaskCommentListComponent';
import { User } from '../../modules/auth';
import PDFViewModal2 from '../expenses/PDFViewModal2';
import AttachedFileListComponent from './AttachedFileListComponent';

interface TaskDetailComponentProps {
  task: Task;
  user: User;
  moveToEditPage(): void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  onOpenCreateTaskCommentModal: () => void;
  openUpdateTaskStatusModal: () => void;
}

function TaskDetailComponent({
  task,
  user,
  moveToEditPage,
  downloadFile,
  onOpenCreateTaskCommentModal,
  openUpdateTaskStatusModal,
}: TaskDetailComponentProps) {
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();
  const [previewFileType, setPreviewFileType] = useState<string>('');

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
    if (file.name.split('.').pop() === 'pdf') {
      setPreviewFileType('pdf');
    } else if (
      file.name.split('.').pop() === 'jpeg' ||
      file.name.split('.').pop() === 'jpg' ||
      file.name.split('.').pop() === 'png'
    ) {
      setPreviewFileType('image');
    } else {
      setPreviewFileType('');
    }
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <Title level={3}>
            업무 상세 (
            {taskStatusKorean[task.status as keyof typeof taskStatusKorean]})
          </Title>
        </Col>
        <Col>
          {task.requester.id === user.id &&
            (task.status === TaskStatus.WORK_REQUEST ||
              task.status === TaskStatus.IN_PROGRESS ||
              task.status === TaskStatus.HOLD ||
              task.status === TaskStatus.CLOSED) && (
              <Button size="small" onClick={() => moveToEditPage()}>
                수정
              </Button>
            )}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Alert
            message={`업무 진행상황을 공유하세요.`}
            type="warning"
            action={
              <Space>
                <Button
                  size="small"
                  type="ghost"
                  onClick={() => openUpdateTaskStatusModal()}
                >
                  상태변경하기
                </Button>
                <Button
                  size="small"
                  type="ghost"
                  onClick={() => onOpenCreateTaskCommentModal()}
                >
                  코멘트 남기기
                </Button>
              </Space>
            }
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }}>
        <Col span={24}>
          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="제목" span={2}>
              {task.name ? task.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="상태">
              {taskStatusKorean[task.status as keyof typeof taskStatusKorean]}
            </Descriptions.Item>
            <Descriptions.Item label="마감일">{task.dueDate}</Descriptions.Item>
            <Descriptions.Item label="요청자">
              {task.requester ? task.requester.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="담당자">
              {task.assignee ? task.assignee.name : ''}
            </Descriptions.Item>
            <Descriptions.Item
              label="업무내용"
              span={2}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {task.description ? task.description : ''}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <div style={{ marginTop: '30px' }}>
        <AttachedFileListComponent
          attachedFiles={task.file}
          downloadFile={downloadFile}
          openImagePreview={openImagePreview}
        />
      </div>
      <div style={{ marginTop: '30px' }}>
        <TaskCommentListComponent
          taskComments={task.taskComments}
          onOpenCreateTaskCommentModal={onOpenCreateTaskCommentModal}
          downloadFile={downloadFile}
          openImagePreview={openImagePreview}
        />
      </div>
      {imageData && previewFileType === 'image' && (
        <Image
          width={200}
          style={{ display: 'none' }}
          preview={{
            visible,
            src: imageData?.url,
            onVisibleChange: (value) => {
              setVisible(value);
              setImageData(null);
              setPreviewFileType('');
            },
          }}
        />
      )}
      {imageData && previewFileType === 'pdf' && (
        <PDFViewModal2
          visible={!!imageData}
          url={imageData.url}
          onCancel={() => {
            setImageData(null);
            setPreviewFileType('');
          }}
          onDownload={() => downloadFile(imageData.id, imageData.name)}
        />
      )}
    </>
  );
}

export default TaskDetailComponent;
